import {AbstractPanel} from '../stats-panel';

export class FPSPanel extends AbstractPanel {
    private _currTime = 0;
    private _prevTime = 0;
    private _frames = 0;

    public constructor(name = 'FPS', bg = '#002', fg = '#0ff', max = 140, decimals = 0) {
        super(name, bg, fg, max, decimals);
    }

    public get value(): number {
        return (this._frames * 1000) / (this._currTime - this._prevTime || 1);
    }

    public update(): void {
        this._frames++;
        this._currTime = performance.now();
    }

    public render(): void {
        super.render();
        this.reset();
    }

    public reset(): void {
        this._prevTime = this._currTime;
        this._frames = 0;
    }

    public onInstall(): void {
        const now = performance.now();

        this._currTime = now;
        this._prevTime = now;
    }

    public onUninstall(): void {
        //
    }
}